<template>
<v-flex>
  <v-col cols="12" mx-0 px-0> </v-col>
  <v-row no-gutters wrap mx-1 px-100>
    <v-col cols="2" mx-0 px-0>
      <!-- Creating Start Button -->
      <v-btn text x-large color="primary"
        :loading = "bState_loading"
        :disabled = "bState_disabled"
       @click="runModel()">
        RUN Digital Twin
      </v-btn>
    </v-col>
    <v-col mx-0 px-0>
      <v-switch
        v-model="calibrate"
        inset
        :label="`Run Calibration: ${calibrate.toString()}`"
        @click="updateCalibration()"
      >Run Calibration</v-switch>
    </v-col>
    <v-col cols="3" mx-0 px-0>
      <v-radio-group row dense v-model="graphType"> 
        <v-radio
          label="Monthly" value='month' @click="changeGraphType('month')"
        ></v-radio>
        <v-radio
          label="Weekly" value='week' @click="changeGraphType('week')"
        ></v-radio>
        <v-radio
          label="Daily" value='day' @click="changeGraphType('day')"
        ></v-radio>
        <v-radio
          label="Hourly" value='hour' @click="changeGraphType('hour')"
        ></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
  <v-row no-gutters wrap mx-1 px-1>
<!------------------------------------------------------------------------------------>
    <!-- Creating Engine Input Section -->
    <v-col cols="2" mx-0 px-0>
      <AppInput />
      <AppTableInput />
    </v-col>

<!------------------------------------------------------------------------------------>     
    <!-- Creating Engine Output Section -->
    <v-col cols="10">
      <AppModel />
      <!-- Main Graph -->
      <v-row wrap mx-2 no-gutters>
        <v-col cols="12">
          <AppMainGraph />
        </v-col>
        <v-col cols="12">
          <AppPieGraph />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</v-flex>
</template>


<script>
import AppTitle from '@/components/shared/Title'
import AppModel from '@/components/subs/kendedaDTW_model'
import AppInput from '@/components/subs/kendedaDTW_input'
import AppTableInput from '@/components/subs/kendedaDTW_tableInput'
import AppMainGraph from '@/components/subs/kendedaDTW_mainGraph'
import AppPieGraph from  '@/components/subs/kendedaDTW_pieGraph'

export default {
  data: () => ({
    mini: true,
    drawer: true,
    dates: ['2020-05-01', '2020-05-10'],
    graphType: 'hour',
    calibrate: false,

    bState_loading: false,
    bState_disabled: false,

  }),
  watch: {
    '$store.state.DTW.run': function() {
      console.log(this.$store.state.DTW.run)
      switch(this.$store.state.DTW.run) {
        case 'idle':
          this.bState_loading = false
          this.bState_disabled = false
        break;
        case 'finished':
          this.bState_loading = false
          this.bState_disabled = false
        break;
        case 'running':
          this.bState_loading = true
          this.bState_disabled = false
        break;
        default:
          this.bState_loading = false
          this.bState_disabled = true
        break;
      }
    }
  },
  computed: {

  },
  methods: {
    runModel() {
      if (this.$store.state.DTW.run === "idle"||this.$store.state.DTW.run === "finished") {
        this.$store.commit("updateDTW_run", "updateVar1")
      }
    },
    updateCalibration() {
       this.$store.commit("updateDTW_calibration", this.calibrate)
    },
    changeGraphType(type) {
       this.graphType = type
       this.$store.commit("updateDTW_graphType",type)
    },
    dateRangeText () {
      this.$store.commit("updateDTW_date",this.dates.sort())
      return '            '.concat(this.dates.sort().join(' ~ '))
    },
  },
  created() {

  },
  components: {
    AppTitle,
    AppModel,
    AppInput,
    AppTableInput,
    AppMainGraph,
    AppPieGraph,
  }
}
</script>

